module.exports = __webpack_public_path__ + "static/media/logo_uob.cd02e013.svg";